import { render, staticRenderFns } from "./index-brand.vue?vue&type=template&id=d2d2eb64&scoped=true&"
import script from "./index-brand.vue?vue&type=script&lang=js&"
export * from "./index-brand.vue?vue&type=script&lang=js&"
import style0 from "./index-brand.vue?vue&type=style&index=0&id=d2d2eb64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d2eb64",
  null
  
)

export default component.exports